import { ApButtonIcon } from '@alixpartners/ui-components';
import React from 'react';
import { Backdrop, ModalContainer, ModalHeader } from './ExpandedModal.styles';

const ExpandedModal = ({ handleClose, children, heading }) => {
	return (
		<Backdrop>
			<ModalContainer>
				<ModalHeader>
					<div>{heading}</div>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => handleClose(false)}
					/>
				</ModalHeader>
				{children}
			</ModalContainer>
		</Backdrop>
	);
};

export default ExpandedModal;
